export const UseCookieAuth = true;
